/** Base URL for the Products API (brand logo and related branding). */
export const PRODUCTS_API_URL = (
  import.meta.env.VITE_PRODUCTS_API_URL ?? ''
).replace(/\/+$/, '');

/** Shared secret sent as the `X-Item` header. */
export const PRODUCTS_API_KEY = import.meta.env.VITE_PRODUCTS_API_KEY ?? '';
